import { render, staticRenderFns } from "./EditBundle.vue?vue&type=template&id=23edd76b&"
import script from "./EditBundle.vue?vue&type=script&lang=js&"
export * from "./EditBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports